module.exports = __webpack_public_path__ + "static/media/2.6f23b284.jpg";